import m from "../../../../geodata/es2015/region/usa/akHigh";
window.am4geodata_region_usa_akHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/akHigh.js
// module id = null
// module chunks = 